import React from "react";
import { useTranslation } from "react-i18next";
import { Select } from "@outpave/ds";
import { CardProgram } from "hooks/useCardPrograms";

interface CardProgramSelectProps {
  programs: CardProgram[];
  value: string;
  onChange: (cardProgramId: string) => void;
  disabled?: boolean;
  /** Shown for no program, which makes the field clearable. */
  placeholder?: string;
}

/**
 * Which program a card is issued against. Shown when the company holds more
 * than one, because otherwise there is nothing to decide, or when a preset
 * already names one.
 */
const CardProgramSelect: React.FC<CardProgramSelectProps> = ({
  programs,
  value,
  onChange,
  disabled,
  placeholder,
}) => {
  const { t } = useTranslation();

  return (
    <Select
      label={t("Card program")}
      value={value || null}
      placeholder={placeholder}
      onChange={(id) => onChange(id ?? "")}
      disabled={disabled}
      clearable={!!placeholder}
      fullWidth
      options={programs.map((program) => ({
        id: program.id,
        label: program.nickname || t("Card program"),
      }))}
    />
  );
};

export default CardProgramSelect;
